// Helpers
import { showNotificationError } from 'Shared/helpers';

// Utils
import WpToastManager from 'Wpds/components/toast/WpToastManager';

// Constants
import FeedbackRequestsConstants from 'Shared/constants/FeedbackRequests.constants';

// API
import * as FeedbackRequestsAPI from 'Shared/api/FeedbackRequests.api';

export const createFeedbackRequestSuccess = payload => ({
  type: FeedbackRequestsConstants.Actions.CREATE_FEEDBACK_REQUEST_SUCCESS,
  payload,
});

export const createFeedbackRequest = ({ workspaceId }) => dispatch => {
  return FeedbackRequestsAPI.createFeedbackRequest({ workspaceId })
    .then(response => {
      dispatch(createFeedbackRequestSuccess(response.data));
      WpToastManager.success('Feedback request was sent');
      return response.data;
    })
    .catch(error => {
      showNotificationError(error);
    });
};
